import { Directive, Input } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';
import { DateUtils } from '@app/utils/date';
import { ngValidatorAccessor } from '@app/utils/ng-validator-accessor';
import { isBlank, isNotBlank } from '@app/utils/string';

@Directive({
  selector: '[portalValidTime]',
  providers: [ngValidatorAccessor(ValidTimeDirective)],
  standalone: false,
})
export class ValidTimeDirective implements Validator {
  @Input()
  required: boolean = false;

  private onValidatorChange = () => {};

  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    let errors: ValidationErrors | null = null;

    if (this.required && isBlank(control.value)) {
      errors = {
        required: true,
      };
    }

    if (isNotBlank(control.value) && DateUtils.isValidTime(control.value) === false) {
      errors = {
        time: {
          key: 'time',
        },
      };
    }

    return errors;
  }
}
